module.exports = __webpack_public_path__ + "img/商品介紹_Mobile.2bfcf2f5.png";